import { Button, DrawerBody, DrawerFooter, DrawerHeader, Radio, RadioGroup, SelectionControlLabel, Typography, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { useCommonContext } from '../../../../hooks/useContexts';
export var SelectReceiptType = function (_a) {
    var closeDrawer = _a.closeDrawer, drawerStepper = _a.drawerStepper, setDrawerStepper = _a.setDrawerStepper;
    var _b = useState('InStore'), formType = _b[0], setFormType = _b[1];
    var isMobile = useCommonContext().isMobile;
    var handleFormChange = function (event) {
        setFormType(event.target.value);
    };
    var handleContinueButton = function (type) {
        if (type === 'Select') {
            setDrawerStepper(1);
            return;
        }
        if (type === 'Scan') {
            setDrawerStepper(4);
            return;
        }
        if (formType === 'InStore') {
            setDrawerStepper(2);
            return;
        }
        if (formType === 'Online') {
            setDrawerStepper(3);
        }
    };
    return (React.createElement("div", { "data-testid": "selectReceiptType", className: "sui-flex sui-flex-col sui-h-full" },
        React.createElement(DrawerHeader, { title: "Add a Receipt", onClose: closeDrawer }),
        React.createElement(DrawerBody, { style: { height: isMobile ? '88vh' : '' } },
            drawerStepper === 0 ? (React.createElement(Typography, { variant: "body-base", weight: "bold" }, "How would you like to add a receipt?")) : (React.createElement(Typography, { variant: "body-base", weight: "bold" }, "What kind of receipt would you like to add?")),
            drawerStepper === 1 && (React.createElement(Typography, { variant: "body-base" }, "Receipts within 13 months of purchase may be added.")),
            drawerStepper === 1 && (React.createElement("div", { className: "sui-mt-[20px]" },
                React.createElement(RadioGroup, { "aria-labelledby": "dataType", name: "dataType", onChange: handleFormChange, value: formType },
                    React.createElement(SelectionControlLabel, { label: "In-Store Receipt", value: "InStore" },
                        React.createElement(Radio, null)),
                    React.createElement(SelectionControlLabel, { label: "Online Receipt", value: "Online" },
                        React.createElement(Radio, null)))))),
        React.createElement(DrawerFooter, null,
            React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col" },
                React.createElement(Button, { onClick: drawerStepper === 0
                        ? function () { return handleContinueButton('Scan'); }
                        : handleContinueButton, variant: "primary" }, drawerStepper === 0 ? 'Scan Receipt' : 'Continue'),
                React.createElement(Button, { onClick: drawerStepper === 0
                        ? function () { return handleContinueButton('Select'); }
                        : closeDrawer, variant: "secondary" }, drawerStepper === 0 ? 'Manually Add Receipt' : 'Cancel')))));
};
